document.addEventListener('alpine:init', () => {

  /* ── Body scroll lock (iOS Safari ignores overflow:hidden on body) ── */
  let _lockedScrollY = 0;
  function lockBodyScroll() {
    if (document.body.style.position === 'fixed') return;
    _lockedScrollY = window.scrollY;
    document.body.style.position = 'fixed';
    document.body.style.top = `-${_lockedScrollY}px`;
    document.body.style.left = '0';
    document.body.style.right = '0';
    document.body.style.width = '100%';
    document.body.style.overflow = 'hidden';
  }
  function unlockBodyScroll() {
    if (document.body.style.position !== 'fixed') return;
    document.body.style.position = '';
    document.body.style.top = '';
    document.body.style.left = '';
    document.body.style.right = '';
    document.body.style.width = '';
    document.body.style.overflow = '';
    window.scrollTo(0, _lockedScrollY);
  }

  /* ── Product ── */
  Alpine.store('product', {
    product: null,
    variants: [],
    selectedVariant: null,
    quantity: 1,
    sellingPlanId: null,
    loading: false,

    init() {
      if (window.__product) {
        this.product = window.__product;
        this.variants = window.__productVariants || [];
        this.selectedVariant = this.variants.find(v => v.available) || this.variants[0];
      }
    },

    get currentVariant() {
      return this.selectedVariant;
    },

    get available() {
      return this.selectedVariant?.available ?? false;
    },

    get price() {
      if (this.selectedVariant && this.sellingPlanId) {
        const alloc = this.selectedVariant.selling_plan_allocations?.find(
          a => a.selling_plan_id === this.sellingPlanId
        );
        if (alloc) return (alloc.price / 100).toFixed(2);
      }
      return this.selectedVariant
        ? (this.selectedVariant.price / 100).toFixed(2)
        : '';
    },

    get compareAtPrice() {
      if (this.selectedVariant && this.sellingPlanId) {
        const alloc = this.selectedVariant.selling_plan_allocations?.find(
          a => a.selling_plan_id === this.sellingPlanId
        );
        if (alloc && alloc.compare_at_price && alloc.compare_at_price !== alloc.price) {
          return (alloc.compare_at_price / 100).toFixed(2);
        }
      }
      if (!this.selectedVariant?.compare_at_price) return '';
      return (this.selectedVariant.compare_at_price / 100).toFixed(2);
    },

    /* Total = unit price × quantity */
    get totalPrice() {
      const unit = parseFloat(this.price);
      if (isNaN(unit)) return '';
      return (unit * this.quantity).toFixed(2);
    },

    get totalCompareAtPrice() {
      const unit = parseFloat(this.compareAtPrice);
      if (isNaN(unit) || !this.compareAtPrice) return '';
      return (unit * this.quantity).toFixed(2);
    },

    selectVariant(variantId) {
      const v = this.variants.find(v => v.id === variantId);
      if (v) {
        this.selectedVariant = v;
        /* Reset selling plan if new variant doesn't have it */
        if (this.sellingPlanId) {
          const hasAlloc = v.selling_plan_allocations?.some(
            a => a.selling_plan_id === this.sellingPlanId
          );
          if (!hasAlloc) this.sellingPlanId = null;
        }
      }
    },

    async addToCart() {
      if (!this.selectedVariant || this.loading) return;
      this.loading = true;

      const payload = {
        id: this.selectedVariant.id,
        quantity: this.quantity
      };

      if (this.sellingPlanId) {
        payload.selling_plan = this.sellingPlanId;
      }

      try {
        await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(payload)
        });

        Alpine.store('cart').open();
        await Alpine.store('cart').refresh();
      } catch (e) {
        console.error('Add to cart failed', e);
      } finally {
        this.loading = false;
      }
    }
  });


  /* ── Product Card Store ── */
  Alpine.store('productCard', {
    loading: null,

    async addToCart(variantId) {
      if (this.loading) return;
      this.loading = variantId;

      try {
        await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: variantId, quantity: 1 })
        });

        Alpine.store('cart').open();
        await Alpine.store('cart').refresh();
      } catch (e) {
        console.error('Quick add failed', e);
      } finally {
        this.loading = null;
      }
    }
  });

  /* ── Cart Drawer Store ── */
  Alpine.store('cart', {
    isOpen: false,
    items: [],
    itemCount: 0,
    totalPrice: '0.00',
    loading: false,

    get hasSubscription() {
      return this.items.some(item => !!item.selling_plan_allocation);
    },

    init() {
      this.refresh();
    },

    toggle() {
      this.isOpen = !this.isOpen;
      if (this.isOpen) {
        this.refresh();
        lockBodyScroll();
      } else {
        unlockBodyScroll();
      }
    },

    open() {
      this.isOpen = true;
      this.refresh();
      lockBodyScroll();
    },
    close() {
      this.isOpen = false;
      unlockBodyScroll();
    },

    // product_id → custom.cart_image URL (rendered by sections/cart-image-map.liquid)
    imageMap: {},

    applyCartImages(items) {
      items.forEach(item => {
        const img = this.imageMap[item.product_id];
        if (img) item.image = img;
      });
    },

    async fetchImageMap() {
      try {
        const res = await fetch('/?sections=cart-image-map');
        const data = await res.json();
        const doc = new DOMParser().parseFromString(data['cart-image-map'] || '', 'text/html');
        const script = doc.querySelector('[data-cart-image-map]');
        this.imageMap = script ? JSON.parse(script.textContent) : {};
      } catch (e) { /* keep default Shopify images */ }
    },

    async refresh() {
      try {
        const [res] = await Promise.all([fetch('/cart.js'), this.fetchImageMap()]);
        const cart = await res.json();
        this.applyCartImages(cart.items);
        this.items = cart.items;
        this.itemCount = cart.item_count;
        this.totalPrice = (cart.total_price / 100).toFixed(2);

        // Enrich items with variant compare_at_price and selling plan discounts
        const handles = [...new Set(this.items.map(i => i.handle))];
        await Promise.all(handles.map(async (handle) => {
          try {
            const pRes = await fetch(`/products/${handle}.js`);
            const product = await pRes.json();
            this.items.forEach(item => {
              if (item.handle === handle) {
                const variant = product.variants.find(v => v.id === item.variant_id);
                if (variant) {
                  // Compare-at price (sale items)
                  if (variant.compare_at_price && variant.compare_at_price > item.final_price) {
                    item._compareAtLinePrice = variant.compare_at_price * item.quantity;
                  }
                  // Selling plan discount: variant regular price vs subscription price
                  if (item.selling_plan_allocation && variant.price > item.final_price) {
                    item._compareAtLinePrice = variant.price * item.quantity;
                  }
                }
              }
            });
          } catch (e) { /* skip enrichment on error */ }
        }));
      } catch (e) {
        console.error('Cart refresh failed', e);
      }
    },

    async updateQuantity(key, quantity) {
      // Optimistic: update local item immediately (no flicker)
      const index = this.items.findIndex(i => i.key === key);
      if (index === -1) return;

      if (quantity <= 0) {
        // Remove locally right away
        this.items.splice(index, 1);
        this.itemCount = this.items.reduce((s, i) => s + i.quantity, 0);
      } else {
        const item = this.items[index];
        const unitPrice = item.final_line_price / item.quantity;
        item.quantity = quantity;
        item.final_line_price = Math.round(unitPrice * quantity);
        this.itemCount = this.items.reduce((s, i) => s + i.quantity, 0);
        this.totalPrice = (this.items.reduce((s, i) => s + i.final_line_price, 0) / 100).toFixed(2);
      }

      // Sync with server
      try {
        const res = await fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: key, quantity })
        });
        const cart = await res.json();

        // Reconcile totals from server (authoritative)
        this.itemCount = cart.item_count;
        this.totalPrice = (cart.total_price / 100).toFixed(2);

        // Patch existing items in-place instead of replacing the array
        const serverItems = cart.items;
        this.applyCartImages(serverItems);
        // Remove items no longer in server response
        for (let i = this.items.length - 1; i >= 0; i--) {
          if (!serverItems.find(s => s.key === this.items[i].key)) {
            this.items.splice(i, 1);
          }
        }
        // Update existing & add new
        serverItems.forEach(si => {
          const local = this.items.find(l => l.key === si.key);
          if (local) {
            Object.assign(local, si);
          } else {
            this.items.push(si);
          }
        });
      } catch (e) {
        console.error('Update quantity failed', e);
        // Rollback on error
        await this.refresh();
      }
    },

    async removeItem(key) {
      await this.updateQuantity(key, 0);
    }
  });


  Alpine.store('mobileMenu', {
    isOpen: false,

    toggle() {
      this.isOpen = !this.isOpen;

      if (this.isOpen) {
        lockBodyScroll();
      } else {
        unlockBodyScroll();
      }
    },

    open() {
      this.isOpen = true;
      lockBodyScroll();
    },
    close() {
      this.isOpen = false;
      unlockBodyScroll();
    }
  })
});
